/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import BrokingSummary from 'components/BrokingSummary';
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import CheckBox from "components/Form/CheckBox";
import { ButtonContent, Title } from "./styles";
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { LostCancelButton } from 'components/index';
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import Loader from 'components/Loader';
import Colors from "constants/Colors";
import { useHeaderNbi, useListContactsByType } from 'services/QuoteService'

export default function ContactsSelection(props) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [summary, setSummary] = useState({});
  const [insurers, setInsurers] = useState([]);
  const [previousItems, setPreviousItems] = useState([]);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useListContactsByTypeData,
    loading: useListContactsByTypeLoading,
    error: useListContactsByTypeError,
    status: useListContactsByTypeStatus,
    request: useListContactsByTypeRequest,
  } = useListContactsByType('insurer-nbi', props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useListContactsByTypeLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useListContactsByTypeLoading]);

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSelect(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };
    const alreadySelected = selectedItems.findIndex((item) => item.idContact === contact.idContact);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.idContact !== contact.idContact);
      setSelectedItems(filteredItems);
    } else {
      console.log(selectedItems)
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
    };
  };

  function listContacts(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }

        const insurers = data.ret_value?.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer))) || [];

        setInsurers(insurers);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${listContacts.name}\n` + error);
        console.error('fitPostListContact - Error:', error);
      });
  };

  function confirmContacts() {
    loading.start()
    let body = {
      idOperation: props.match.params.idOperation,
      insurers: []
    }
    insurers.forEach(x => {
      body.insurers.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })
    selectedItems.forEach(x => {
      let i = body.insurers.findIndex(e => e.idPersonInsurer == x.idPersonInsurer);
      if (i != -1) {
        body.insurers[i].contacts.push({ idContact: x.idContact, email: x.email });
      }
    })
    const atLeastOneSelected =  atLeastOneInsurerContatctSelected(insurers, selectedItems)
    if(!atLeastOneSelected){
      loading.stop();
      mc.error('Please, select at least one contact for insurer');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestConfirmContacts(props.match.params.idOperation, body.insurers.filter(x => x.contacts.length > 0)).then(response => response.json())
      .then(data => {
        if (data.ret_code === 200) {
          loading.stop();
          history.push(`/broking/send-nbi-request/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct });
        } else {
          loading.stop();
          mc.error(data.ret_msg_details);
        }
      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${confirmContacts.name}\n` + error);
        console.error('fitPostConfirmContact - Error:', error);
      });
  };

  function atLeastOneInsurerContatctSelected(insurers, selectedItems){
    let hasAllContact = true;
    let hasContact = false;
    insurers.map(insurer =>{
      hasContact = selectedItems.find(contact => contact.idPersonInsurer == insurer.idPersonInsurer)
      if(!hasContact) hasAllContact = false;
    })
    return hasAllContact;
  }

  function handleBack() {
    history.goBack();
  }

  const listItems = insurers.length ? insurers.map((insurer) => {
    if (previousItems.find((item) => insurer.contacts.find(contact => item.idContact === contact.idContact))) return <></>;

    return (
      <>
        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
          <Title>
            {insurer.insurerFirstName}
          </Title>
        </Row>
        {
          insurer.contacts.length ? insurer.contacts.map((contact) => {
            return (
              <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                <Col style={{ flexDirection: "row", display: "flex" }}>
                  <label>
                    <CheckBox
                      onChange={() => { handleSelect(contact, insurer) }}
                      checked={selectedItems.find((item) => item.idContact === contact.idContact) ? true : false}
                    />
                  </label>
                  <Label > {contact.legalEntity}</Label>
                </Col>

                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                  <Label >{contact.nameContact}</Label>
                </Col>
                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                  <Label >{contact.personContactDepartment}</Label>
                </Col>
                <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                  <Label >{contact.email}</Label>
                </Col>
              </Row>
            )
          })
            : (
              <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                <Label>
                  No results found.
                </Label>
              </Row>
            )
        }
      </>
    )
  }) : (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Title>
        No results found.
      </Title>
    </Row>)

  useEffect(() => {
    if (insurers.length > 0) {
      let list = [];
      insurers.forEach(insurer => {
        insurer.contacts.forEach(contact => {
          if (contact.existContact) {
            handleSelect(contact, insurer);
            list.push({ idPersonInsurer: insurer.idPersonInsurer, idContact: contact.idContact, email: contact.email });
          }
        })
      })
      setSelectedItems([...list]);
      setPreviousItems([...list]);
    }
  }, [insurers])


  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    listContacts();
    handleSummary();
    console.log("Itens passados-> ", props.location.state);
  }, [])



  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard
        title="SELECT UNDERWRITERS"
        icon
        info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
        filterContact
        handleFilterContact={(idContactDepartment) => listContacts(idContactDepartment)}
      >
        <Title>TO</Title>
        {listItems}
        <ButtonContainer>
          <Button forth onClick={() => handleBack()}>&lt; Back</Button>
          <RenderButtons idOperation={props.match?.params?.idOperation}>
            <ButtonContent>
              <div style={{ marginTop: "5px" }}>
                <LostCancelButton idOperation={props.match?.params?.idOperation} />
              </div>
              <Button
                style={{ marginLeft: "10px", marginTop: "5px" }}
                primary
                onClick={() => confirmContacts()}
              >
                NEXT
              </Button>
            </ButtonContent>
          </RenderButtons>
        </ButtonContainer>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ContentCard>
    </Layout>
  );
}
